'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pager = require('react-bootstrap/lib/Pager');

var _Pager2 = _interopRequireDefault(_Pager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pager2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/Pager.js
// module id = 655
// module chunks = 0